import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import './App.css';


function App() {
  const [data, setData] = useState([]);
  const [granularity, setGranularity] = useState('minute');
  const [duration, setDuration] = useState('1h');
  const apiURL = "https://cozydrain-demo-api.lukacosic.com";

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(`${apiURL}/api/get_data?granularity=${granularity}&duration=${duration}`);
      setData(response.data.map(item => ({
        timestamp: new Date(item[0]),
        'Valve cold': item[1],
        'Valve hot': item[2],
        'Valve warm': item[3],
        temperature: item[4],
        flowRate: item[5]
      })));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }, [granularity, duration]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDownloadDB = async () => {
    try {
      const response = await axios.get(`${apiURL}/api/download_db`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'dashboard.db');
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error('Error downloading database:', error);
    }
  };

  const CustomLegend = (props) => {
    const { payload } = props;
    return (
      <ul className="custom-legend">
        {payload.map((entry, index) => (
          <li key={`item-${index}`} style={{ color: entry.color }}>
            {entry.value}
          </li>
        ))}
      </ul>
    );
  };

  const renderChart = (dataKey, yAxisDomain, title, unit) => (
    <div className="chart">
      <h2>{title}</h2>
      <ResponsiveContainer width="100%" height={500}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="timestamp" tickFormatter={(tick) => new Date(tick).toLocaleTimeString()} />
          <YAxis 
            domain={yAxisDomain} 
            tickFormatter={(value) => value.toFixed(1)}
          />
          <Tooltip 
            labelFormatter={(label) => new Date(label).toLocaleString()} 
            formatter={(value) => value.toFixed(1)}
          />
          <Legend content={<CustomLegend />} />
          {Array.isArray(dataKey) ? (
            dataKey.map((key, index) => (
              <Line key={index} type="monotone" dataKey={key} stroke={`#${Math.floor(Math.random()*16777215).toString(16)}`} />
            ))
          ) : (
            <Line type="monotone" dataKey={dataKey} stroke="#8884d8" />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );

  return (
    <div className="App">
      <h1>CozyDrain Dashboard</h1>
      <p>Auckland installation</p>
      <div className="controls">
        <select value={granularity} onChange={(e) => setGranularity(e.target.value)}>
          <option value="second">Second</option>
          <option value="minute">Minute</option>
          <option value="hour">Hour</option>
        </select>
        <select value={duration} onChange={(e) => setDuration(e.target.value)}>
          <option value="1h">Last 1 hour</option>
          <option value="6h">Last 6 hours</option>
          <option value="24h">Last 24 hours</option>
          <option value="7d">Last 7 days</option>
        </select>
        <button onClick={fetchData}>Refresh Data</button>
        <button onClick={handleDownloadDB}>Download Database</button>
      </div>
      {renderChart(['Valve cold', 'Valve hot', 'Valve warm'], [0, 1], 'Valve States', '')}
      {renderChart('temperature', [2, 65], 'Water Temperature', '°C')}
      {renderChart('flowRate', 'auto', 'Flow Rate', '')}
    </div>
  );
}

export default App;
